module.exports = __webpack_public_path__ + "img/ic-plus-slate60.b0e3d96d.svg";